export default "__VITE_ASSET__ixq0Jzyu__"